/**
 * Training hooks (TanStack Query) — the training component catalogue, backing
 * apps/learn and apps/mentor.
 *
 * What a trainee is working TOWARD is no longer here. `/learning-goals` is not
 * a route any more: a goal is a target on one skill, it lives on the
 * `(user, skills)` stream, and both boards read it through useSkills.ts.
 *
 * Nothing in this file writes. A training component is a protocol, authored
 * in the protocol Studio (tricorder-studio-web) like any other.
 */

import { useAuthenticatedQuery } from '@/hooks/useAuthenticatedQuery';
import {
  listProtocols,
  type ListProtocolsParams,
  type ProtocolSummary,
} from '@/api/endpoints/protocols';

export const trainingKeys = {
  all: ['training'] as const,
  components: () => [...trainingKeys.all, 'components'] as const,
  componentsList: (params?: ListProtocolsParams) =>
    [...trainingKeys.components(), params] as const,
};

/** GET /protocols — the catalogue (recommendations, target modules, the quiz shelf). */
export function useTrainingComponents(params: ListProtocolsParams = {}) {
  return useAuthenticatedQuery<ProtocolSummary[]>({
    queryKey: trainingKeys.componentsList(params),
    queryFn: () => listProtocols(params),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
}
